<template>
    <label
        class="common-drop-zone"
        v-on:drop.stop.prevent="onFileChange"
        v-on:dragover.prevent
        v-bind:class="{
            _loading: isLoading,
            _error: error,
        }"
        v-bind:for="inputId"
    >
        <div class="common-drop-zone__info">
            <div
                class="common-drop-zone__info-icon"
                v-bind:class="{ '_error': error }"
            >
                <icon name="upload-file" width="14" height="18" />
            </div>
            <div
                class="common-drop-zone__info-text-title"
                v-bind:class="{ '_error': error }"
            >
                {{ title }}<span v-if="required" class="_required">*</span>
            </div>
            <div
                class="common-drop-zone__info-text-description"
                v-bind:class="{ '_error': error }"
                v-text="description"
                v-if="description"
            />
            <div
                class="common-drop-zone__info-text-description"
                v-bind:class="{ '_error': error }"
                v-text="givenError"
                v-if="givenError"
            />
            <template v-if="internalErrors">
                <div
                    class="common-drop-zone__info-text-description _error"
                    v-for="(internalError, index) in internalErrors"
                    :key="index"
                    v-text="internalError"
                />
            </template>
            <div class="common-drop-zone__info-buttons">
                <ui-button
                    v-bind:disabled="isLoading"
                    text="Выбрать файлы"
                    theme="secondary"
                    size="sm"
                />
            </div>
        </div>
        <input
            class="common-drop-zone__input"
            type="file"
            ref="input"
            multiple
            v-bind:id="inputId"
            v-on:change="onFileChange"
            v-bind:disabled="isLoading"
        />
        <!-- accept=".jpg, .jpeg, .png, .pdf" -->
    </label>
</template>

<script>
export default {
    name: 'common-drop-zone',
    props: {
        title: {
            type: String,
            default: 'Выберите или перенесите файлы',
        },
        description: {
            type: String,
            default: '',
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        givenError: {
            type: String,
            default: null,
        },
        limit: {
            type: Number,
            default: 8, // 8 Mb
        },
        // validFileTypes: [ 'image/jpeg', 'image/pjpeg', 'image/png', 'application/pdf' ],
        validFileTypes: {
            type: Array,
            default: () => [],
        },
        required: Boolean,
    },
    model: {
        prop: 'file',
        event: 'change',
    },
    data: () => ({
        internalErrors: null,
    }),
    computed: {
        error() {
            return !!this.givenError;
        },
        inputId() {
            return 'upload-photo-' + this._uid;
        },
    },
    methods: {
        isValidFileType(file) {
            return this.validFileTypes.length === 0 || this.validFileTypes.indexOf(file.type) > -1;
        },
        onFileChange(e) {
            this.internalErrors = null;
            const files = e.type === 'drop' ? e.dataTransfer?.files : e.target?.files;
            if (files && files.length > 0) {
                this.setImage(files);
            } else {
                this.$emit('change', null);
            }
        },
        setImage(files) {
            if (files && files.length > 0) {
                this.internalErrors = [];
                const filesArr = Array.from(files);
                for (const file of filesArr) {
                    if (!this.isValidFileType(file)) {
                        this.internalErrors.push(`Файл ${file.name} имеет недопустимый тип (поддерживаются jpg, png, pdf)`);
                        file.error = true;
                    }
                    if (file.size > this.limit * 1024 * 1024) {
                        this.internalErrors.push(`Файл ${file.name} превышает допустимый размер (лимит ${this.limit} Мб)`);
                        file.error = true;
                    }
                }
                const filteredFiles = filesArr?.filter(f => !f.error);
                if (filteredFiles.length !== 0) {
                    this.$emit('change', filteredFiles);
                }
            }
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.common-drop-zone {
    position: relative;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: @border-radius-md;
    border: 1px dashed currentColor;
    overflow: hidden;

    color: @color-gray-main;

    background-color: @color-gray-lighter;

    cursor: pointer;

    &._loaded {
        border-style: solid;
        border-color: @color-gray-light-secondary;
        color: @color-primary;
    }
    &._error {
        color: @color-accent-negative;
    }
    &._loading {
        pointer-events: none;
    }
    &__info {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;

        position: relative;
        z-index: 1;

        width: 100%;
        height: 100%;
        padding: 16px;

        &-content {
            display: flex;
            align-items: center;
            gap: 12px;
            flex: 1;
        }
        &-buttons {
            color: @color-primary;
        }
        &-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            width: 24px;
            height: 24px;
            color: @color-gray-darker;

            &._error {
                color: @color-accent-negative;
            }
            &._done {
                color: @color-positive;
            }
        }
        &-text {
            display: flex;
            flex-direction: column;
            gap: 4px;

            &-title {
                .typography-body();

                color: @color-gray-darker;

                &._error {
                    color: @color-accent-negative;
                }
                & ._required {
                    color: @color-accent-negative;
                    padding-left: 2px;
                }
            }
            &-description {
                .typography-caption();

                color: @color-gray-main;

                &._error {
                    color: @color-accent-negative;
                }
            }
        }
    }
    &__input {
        position: absolute;
        z-index: -1;

        opacity: 0;
    }
}
</style>
